import React from 'react'
import './DateRangeField.scss'
import { DatePicker, Form } from 'antd'
import moment from 'moment'

import { ReactComponent as CalendarIcon } from '../../assets/icons/calender.svg'
import { DATE_FORMATS } from '../../utils/constants/constant'

const { RangePicker } = DatePicker

// Editable date-range counterpart to DateField (which only wraps a single
// DatePicker) -- used wherever a user picks a start+end range, e.g. Delivery
// Progress's Week Reference.
const DateRangeField = ({
  placeholder,
  name,
  onRangeChange,
  label,
  existingValue,
  rules,
  disabled,
  disabledDate,
  popupClassName,
  required,
}) => {
  return (
    <Form.Item
      label={label}
      className="text-field"
      required={required}
      rules={rules}
      name={name}
      initialValue={
        existingValue
          ? [
              moment(existingValue[0], DATE_FORMATS.DD_MMM_YYYY),
              moment(existingValue[1], DATE_FORMATS.DD_MMM_YYYY),
            ]
          : undefined
      }
    >
      <RangePicker
        className="date-field text-field"
        onChange={(dates, dateStrings) => {
          onRangeChange && onRangeChange(dates, dateStrings, name)
        }}
        placeholder={placeholder}
        format={DATE_FORMATS.DD_MMM_YYYY}
        disabled={disabled}
        allowClear
        disabledDate={disabledDate}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        popupClassName={popupClassName}
        suffixIcon={<CalendarIcon />}
      />
    </Form.Item>
  )
}

export default DateRangeField
